import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const DesignIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 16 16">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={1.5}
				strokeMiterlimit={10}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M13.2827 5.9668L8.93599 10.3135C8.42266 10.8268 7.58266 10.8268 7.06932 10.3135L2.72266 5.9668"
			/>
		</SvgIcon>
	)
}

export default DesignIconAtom
